import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { BorderTop, Height, Padding } from '@mui/icons-material';
import OriginService from '../../services/OriginService/OriginService';
// Define component styling
const useStyles = makeStyles((theme) => ({

    alertOverlay: {
        width: "100vw",
        height: "100vh",
        position: "fixed",
        background: "#18171775",
        zIndex: 99999999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        backdropFilter: "blur(2px)",
        WebkitBackdropFilter: "blur(5px)",
    },

    mainGrid: {
        border: "1px solid white",
        padding: "15px",
        borderRadius: "10px",
        color: "#79232e",
        background: "#ffffff",
        width: "36%",
        height: "150px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",

    },
    buttonMain: {
        display: "flex",
        justifyContent: "end",
        gap: ".5rem",
        borderTop: "1px solid #79232e",
        paddingTop: "8px",
    },

    button: {
        background: "#79232e",
        width: "104px",
        color: "white",
        borderRadius: "50px",
        fontSize: "12px",
        transition: "0.3s",
        "&:hover": {
            background: "#887e7e",
            color: "#fff",
        },
    },
    buttonReset: {
        background: "#887e7e",
        borderRadius: "50px",
        transition: "0.3s",
        "&:hover": {
            background: "#79232e",
        },
    },

}));

/*
this page showing login error message on the UI
*/
const SessionTimeoutAlert = (props) => {

    const classes = useStyles();
    const host = props.host;
    const handleClose = async () => {
        const proxy = await host;
        const close = await proxy.close();

        return close;
    };

    const handleResetToken = async () => {

        const proxy = await host;
        const originContext = await proxy.getTransactionOrigin();
        const originId = originContext.id;
        const partnerAccessToken = originContext.partnerAccessToken;
        const origin = OriginService(originId, partnerAccessToken);
        const originLoanData = await origin.getOriginLoanData();
        const newToken = JSON.parse(localStorage.getItem('auth'));
        props.setTokenUpdatedAt(Date.now());
        props.setToken(newToken);
        props.setShowTimer(false);
    }

    useEffect(() => {
        if (props.secondsLeft === 0) {
            handleClose();
        }
    }, [props.secondsLeft]);

    return (
        <>
            {props.showTimer == true && (
                <Box className={classes.alertOverlay}>
                    <Grid className={classes.mainGrid}>
                        <Grid>
                            <Typography variant="h5" component="div">
                                Session Expired
                            </Typography>
                            <Typography variant="p" component="div">
                                your session will expire in {props.secondsLeft} seconds
                            </Typography>
                        </Grid>
                        <Box component="span" className={classes.buttonMain}>
                            <Button variant="contained" className={`${classes.button} ${classes.buttonReset}`} onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button variant="contained" className={classes.button} onClick={handleResetToken}>
                                Reset
                            </Button>
                        </Box>
                    </Grid>
                </Box>
            )}

        </>

    )
};

export default SessionTimeoutAlert;
